// extracted by mini-css-extract-plugin
module.exports =  {"modalWidth":"340px","modal":"modal--srFEb","content":"content--Lwuge"};